export enum ProductLabelStatus {
	ToDo = "ToDo",
	Ready = "Ready",
}
